import * as React from 'react';
import { IBuilder } from '../../types/project';
import { Avatar, Overline, Responsive, UIHeading3, UIHeading4, UIText2, UIText3 } from '@cian/ui-kit';
import { IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './BuilderInfo.css';
import { Factoid } from './components/Factoid';
import escrowIcon from './assets/escrow.svg';
import { NBSP } from '../../constants/symbols';

interface IBuilderInfoProps extends IBuilder {
  reliable?: boolean;
  withEscrow?: boolean;
}

export const BuilderInfo: React.FC<IBuilderInfoProps> = ({
  name,
  logo,
  url,
  foundationYear,
  projectsCount,
  reliable,
  withEscrow,
}) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        <Avatar size={72} type="builder" src={logo} href={url} target="_blank" />
        <div className={styles['company']}>
          <Overline color="text-secondary-default">Строительная компания</Overline>
          <UIHeading3>
            <a className={styles['link']} href={url} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          </UIHeading3>
          {reliable && (
            <div className={styles['reliable']}>
              <IconProductTrust16 color="icon-main-default" />
              <UIText3>Надежная компания</UIText3>
            </div>
          )}
        </div>
        {(foundationYear || projectsCount) && (
          <div className={styles['factoids']}>
            {!!foundationYear && <Factoid title="Год основания" value={foundationYear} />}
            {!!projectsCount && <Factoid title="Проектов" value={projectsCount} />}
          </div>
        )}
        {withEscrow && (
          <Responsive desktop>
            <div className={styles['escrow-block']}>
              <img src={escrowIcon} width={40} height={40} />
              <div>
                <UIHeading4>Безопасная сделка с эскроу-счётом</UIHeading4>
                <UIText2 color="text-secondary-default">
                  Подрядчик получит деньги{NBSP}только после завершения строительства и{NBSP}передачи готового дома
                  заказчику
                </UIText2>
              </div>
            </div>
          </Responsive>
        )}
      </div>
    </div>
  );
};
